// ============================================================================
// SANDBOX APPROVAL PAGE
// Standalone page for admins to review and approve/reject sandbox requests
// ============================================================================

import React from 'react';
import { Cloud } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import SandboxApprovalQueue from '../components/governance/SandboxApprovalQueue';

const SandboxApprovalPage: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  const isAdmin = user.role === 'system_admin';

  if (!isAdmin) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <h2 className="text-lg font-bold text-slate-900">Access Denied</h2>
          <p className="text-sm text-slate-500 mt-1">You need administrator privileges to access this page.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto p-8">
      {/* Header */}
      <div className="flex items-center gap-3 mb-8">
        <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary to-cyan-600 flex items-center justify-center">
          <Cloud size={24} className="text-white" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Sandbox Approval Queue</h1>
          <p className="text-sm text-slate-500">Review and approve sandbox environment requests</p>
        </div>
      </div>

      {/* Content */}
      <SandboxApprovalQueue organizationId={user.organizationId} />
    </div>
  );
};

export default SandboxApprovalPage;
